import { createComponent } from '@cian/mf-react-legacy';
import { IParameters } from '@cian/mf-registry-legacy/shared';
import * as React from 'react';

import * as styles from './Recommendations.css';
import { RECOMMENDATIONS_MICROFRONTEND_NAME, RECOMMENTATIONS_MICROFRONTEND_PATH } from '../../constants/microfrontend';
import classNames from 'classnames';

interface IRecommendationsProps extends IParameters {
  regionId: number;
  landingType: string;
  showFullList: number;
}

const RecommendationsComponent = createComponent<IRecommendationsProps>({
  mcs: RECOMMENDATIONS_MICROFRONTEND_NAME,
  path: RECOMMENTATIONS_MICROFRONTEND_PATH,
});

export const Recommendations: React.VFC<IRecommendationsProps> = ({ regionId, landingType, showFullList = 0 }) => (
  <section
    className={classNames('cg-container-fluid-xs', styles['container'], !!showFullList && styles['reset-padding'])}
  >
    <RecommendationsComponent
      regionId={regionId}
      landingType={landingType}
      showFullList={showFullList}
    ></RecommendationsComponent>
  </section>
);
